// src/coursePasses/index.js - the Courses page in admin (People group), v133.58.
// Bundled by esbuild -> dist/coursePasses.js (globalName "CoursePasses"), loaded in admin.html, drawn into
// #page-coursepasses.
//
// The Virtual Store's long courses (Train the trainer, and more to come), recorded in Shift when a member
// of staff passes a module and types their PIN (migration v232-0). Who has done which course, how far
// they are, when, and the commitment they chose for the week: a conversation starter for their manager.
// Evidence of learning, not a qualification. The Worker decides who sees whom (Head Office everyone, an
// area manager the people whose home store is in their area).
import { courseInfo } from '../shared/course-catalogue.js';

function authHeaders() {
  const t = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
  const h = { 'Content-Type': 'application/json' };
  if (t) h['Authorization'] = 'Bearer ' + t;
  return h;
}
function workerBase() { return (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : ''; }
const esc = (s) => (window.escapeHtml ? window.escapeHtml(s) : String(s == null ? '' : s));
function when(d) {
  try { return new Date(String(d).slice(0, 10) + 'T00:00:00Z').toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }); } catch (e) { return d || ''; }
}

let _filter = '';

export async function render() {
  const page = document.getElementById('page-coursepasses'); if (!page) return;
  page.innerHTML = '<div id="lqCard"></div><div id="cpBody"></div>';
  leaderCard();   // v133.70: the leadership quiz download sits above the courses
  const host = document.getElementById('cpBody');
  host.innerHTML = '<div class="card"><div style="color:var(--sub);font-size:13px;padding:10px 0">Loading courses...</div></div>';
  let d;
  try {
    const res = await fetch(workerBase() + '/api/admin/course-passes', { cache: 'no-store', headers: authHeaders() });
    d = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error((d && d.error) || ('HTTP ' + res.status));
  } catch (e) {
    host.innerHTML = '<div class="card"><div style="color:var(--red);font-size:13px;padding:10px 0">Could not load the courses: ' + esc(e.message) + '</div></div>';
    return;
  }
  draw(host, d);
}

function draw(host, d) {
  const intro = '<p style="color:var(--sub);font-size:13px;margin:0 0 10px">Long courses in the Virtual Store\'s Training Academy. A module is recorded here when a member of staff passes its check and types their PIN. It shows what they have learned and the one thing they chose to do that week: a good start for a conversation. It is not a qualification.</p>';
  if (!d.ready) {
    host.innerHTML = '<div class="card">' + intro + '<div style="color:var(--sub);font-size:13px">Courses are not recorded yet (database update v232-0).</div></div>';
    return;
  }
  const people = Array.isArray(d.people) ? d.people : [];
  if (!people.length) {
    host.innerHTML = '<div class="card">' + intro + '<div style="color:var(--sub);font-size:13px">Nobody has passed a course module yet.</div></div>';
    return;
  }
  const q = _filter.trim().toLowerCase();
  const shown = q ? people.filter((p) => (String(p.name) + ' ' + String(p.store)).toLowerCase().indexOf(q) !== -1) : people;
  const rows = shown.map((p) => {
    const courses = Object.keys(p.courses || {}).map((id) => {
      const info = courseInfo(id), c = p.courses[id];
      const of = info.modules ? c.modules + ' of ' + info.modules : String(c.modules);
      const done = info.modules && c.modules >= info.modules;
      return '<div>' + esc(info.title) + ': <b' + (done ? ' style="color:var(--green)"' : '') + '>' + esc(of) + '</b>' + (done ? ' (complete)' : '') + '</div>';
    }).join('');
    return '<tr><td translate="no" style="font-weight:600">' + esc(p.name) + '</td><td translate="no">' + esc(p.store) + '</td><td>' + courses + '</td><td style="white-space:nowrap">' + esc(when(p.last)) + '</td><td translate="no" style="color:var(--sub)">' + esc(p.commitment || '') + '</td></tr>';
  }).join('');
  host.innerHTML = '<div class="card">' + intro
    + '<input type="search" class="form-input" id="cpFilter" placeholder="Search a name or store" value="' + esc(_filter) + '" style="max-width:280px;margin-bottom:10px">'
    + '<div style="overflow-x:auto"><table class="table" style="width:100%;font-size:13px"><thead><tr><th style="text-align:start">Person</th><th style="text-align:start">Store</th><th style="text-align:start">Courses</th><th style="text-align:start">Last passed</th><th style="text-align:start">Their latest commitment</th></tr></thead><tbody>' + rows + '</tbody></table></div></div>';
  const f = document.getElementById('cpFilter');
  if (f) f.addEventListener('input', () => { _filter = f.value; const pos = f.selectionStart; draw(host, d); const g = document.getElementById('cpFilter'); if (g) { g.focus(); try { g.setSelectionRange(pos, pos); } catch (e) {} } });
}

// ---------------------------------------------------------------- the leadership quiz (v133.70)
// Matt sends the link (leader.html) to the store managers and downloads the results here for the deck.
// Head Office only (the Worker refuses anyone else; the card then says so).
async function leaderCard() {
  const box = document.getElementById('lqCard'); if (!box) return;
  const link = (location.hostname.indexOf('staging') !== -1 ? location.origin : 'https://elcapp-shift.netlify.app') + '/leader.html';
  const card = (inner) => '<div class="card" style="margin-bottom:12px"><div style="font-weight:700;margin-bottom:4px">Leadership quiz</div>' + inner + '</div>';
  let d;
  try {
    const res = await fetch(workerBase() + '/api/admin/leader-quiz', { cache: 'no-store', headers: authHeaders() });
    d = await res.json().catch(() => ({}));
    if (res.status === 403) { box.innerHTML = ''; return; }
    if (!res.ok) throw new Error((d && d.error) || ('HTTP ' + res.status));
  } catch (e) {
    box.innerHTML = card('<div style="color:var(--red);font-size:13px">Could not load the leadership quiz: ' + esc(e.message) + '</div>');
    return;
  }
  const linkLine = '<div style="font-size:13px;color:var(--sub);margin-bottom:8px">The link to send: <a href="' + esc(link) + '" target="_blank" rel="noopener">' + esc(link) + '</a></div>';
  if (!d.ready) { box.innerHTML = card(linkLine + '<div style="color:var(--sub);font-size:13px">Not set up yet (database update v234-0).</div>'); return; }
  box.innerHTML = card(linkLine + '<div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap"><span style="font-size:13px">' + esc(String(d.count)) + (d.count === 1 ? ' person has' : ' people have') + ' done it.</span>'
    + '<button class="btn btn-primary" type="button" id="lqDownload"' + (d.count ? '' : ' disabled') + '>Download the results</button><span id="lqMsg" style="font-size:13px;color:var(--sub)"></span></div>');
  const btn = document.getElementById('lqDownload');
  if (btn) btn.addEventListener('click', async () => {
    const msg = document.getElementById('lqMsg'); btn.disabled = true; if (msg) msg.textContent = 'Preparing...';
    try {
      const res = await fetch(workerBase() + '/api/admin/leader-quiz/export.csv', { cache: 'no-store', headers: authHeaders() });
      if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.error || ('HTTP ' + res.status)); }
      const url = URL.createObjectURL(await res.blob());
      const a = document.createElement('a'); a.href = url; a.download = 'leadership-quiz-' + new Date().toISOString().slice(0, 10) + '.csv';
      document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 2000);
      if (msg) msg.textContent = '';
    } catch (e) { if (msg) msg.textContent = 'Could not download: ' + e.message; }
    btn.disabled = false;
  });
}
